<script>
    import { t } from "$lib/i18n/translations";
    import Clear from "$components/icons/Clear.svelte";

    export let click;
</script>

<div
    class="cursor-pointer inline-block"
    on:click={click}
    aria-hidden="true"
    aria-label={$t("save.clear_input")}
>
    <Clear />
</div>

<style>
</style>
